import {useState,useEffect} from "react"
import axios from "axios"
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom'
import {baseURL,baseURLStatic} from "../../services/authentication.js"
import styled from "styled-components";
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';





const Container=styled.div`
	display:flex;
	flex-direction:column;
	border: 1px solid grey;
	border-radius:8px;
	align-items:center;	
	margin-top:10px
`;

const Formulario=styled.form`
	display:flex;
	flex-direction:column;
	width:100%;
	align-items:center
`;


const InputsFile=styled.div`
	visibility:hidden; 
	display:flex;
	flex-direction:column
`;

const ContainerCombo=styled.div` 
	display:flex;
	margin:10px;
	flex-direction:column;
`;

const Seccion=styled.div`
	padding:15px;
	width:94%;
	display:flex;
	align-items:center;
	justify-content:space-around;
	background-color:#F7F6F6;
	margin:5px;
	border-radius:8px;
`;

let Label=styled.label`
	font-size:16px;

`;

export default function Upload(){
	const [categorias,setCategorias]=useState([]);
	let [send,setSend]=useState(false)
	let isLogin=useSelector(state=>state.isloguin);
	let navigate=useNavigate();	
	//let token=getToken();
	

	useEffect(()=>{
		if(isLogin==="false"||isLogin===false) {navigate("/")};  
		axios(baseURL+"/categorias")
		.then(datos=>datos.data)
		.then(datos=>setCategorias(datos));	
	},[])
		



	let showElement=(id,show)=>{
		let ele=document.getElementById(id);
		ele.style.visibility= show?"visible":"hidden";
	};


	let selectOnChange=(e)=>{
		
		let comboId=e.target.id;
		if(e.target.value==="0"){
			showElement(`ruta${comboId}`,true);
	    }else {
		  	showElement(`ruta${comboId}`,false);
	      	
	   }	
	};	


	let sendVideo=async()=>{
		try{
			let video=document.getElementById("video").files[0];
			const formVideo = new FormData();
			formVideo.append("video",video);
			const datoVideo=Object.fromEntries(formVideo.entries());
			let rpta= await axios.post(baseURLStatic+'/videos/',datoVideo,{headers: {"Content-Type": "multipart/form-data"} });
			return rpta.data
		}catch(err){console.log(err); throw new Error(err)}
	};

	let sendPoster=async()=>{
		try{
			let imagen=document.getElementById("poster").files[0];
			const formImagen = new FormData();
			formImagen.append("imagen",imagen);
			const datoImagen=Object.fromEntries(formImagen.entries());
			let rpta= await axios.post(baseURLStatic+'/imagenes/',datoImagen,{headers: {"Content-Type": "multipart/form-data"} });
			return rpta.data
		}catch(err){console.log(err); throw new Error(err)}
	};

	let sendTutorial=async(e)=>{
		e.preventDefault();	
		try{			
				let urlVideo= await sendVideo();
				let urlPoster = await sendPoster();
				let nombre=document.getElementById("nombre").value;
				let descripcion=document.getElementById("descripcion").value;
				let categoria=document.getElementById("Categoria").value;
				let promo=document.getElementById("promo").value;
				
				const form = new FormData();
				form.append("nombre",nombre);
				form.append("descripcion",descripcion);
				form.append("categoria",categoria);
				form.append("urlVideo",urlVideo);
				form.append("imagen",urlPoster);
				form.append("promo",promo);	

				const datosCompletos=Object.fromEntries(form.entries());
				console.log(datosCompletos);
			/*	
				await axios.post(baseURL+'/farmasistutorials/',datosCompletos)
			 	.then(res=>{alert("tutorial correctamente subido" )  })
			 	.catch((err) => (console.log("Error api: " + err)));
			*/

		}catch(err){alert("error al moneto de grabar el tutorial"); console.log(err)}	



		}
		

	
	

	return(
		<Container>
			<Label>Crear tutorial</Label>

			<Formulario enctype='multipart/form-data'  onSubmit={sendTutorial} >
				<Seccion>
						<Label>Nombre tutorial :</Label>
						<TextField id="nombre" label="nombre" variant="outlined" placeholder="ingrese nombre del video" size="small" fullWidth disabled={send}/>
						
				</Seccion>
				<Seccion>
					<Label>Descripcion tutorial :</Label>
					<TextareaAutosize maxRows={10} minRows={5} id="descripcion"  aria-label="maximum height"  style={{ width: 900 }} disabled={send} />
				</Seccion>
				
				<Seccion>
					<Label>Selecionar video para tutorial :</Label>
					<input id="video"  type="file" disabled={send}/>
				</Seccion>
				<Seccion>	
					<Label>Selecionar poster tutorial :</Label>
					<input id="poster" type="file" disabled={send}/>
				</Seccion>
				
				<Seccion>
					<Label>Selecionar video para tutoriales :</Label>
					<ContainerCombo>
						<select  id="Categoria"  onChange={selectOnChange} disabled={send}>
				    		<option value="" disabled selected>selecionar categoria</option>
							{categorias.map( ele=><option key={ele.id} value={ele.id}>{ele.descrip}</option> )}
							<option  value="0">nueva categoria</option>
						</select>		
					</ContainerCombo>
					<InputsFile id="rutaCategoria">
						<TextField id="nuevaCategoria" label="nueva categoria" variant="outlined" placeholder="ingresar nombre de nueva categoria" size="small" disabled={send}></TextField>							
					</InputsFile>
				</Seccion>
				<Seccion>
					<Label> Promocionar como herramienta avanzada?</Label>
					<select  id="promo" disabled={send} >			    	
						<option key={0} value={0}>no</option>
						<option key={1} value={1}>si</option>
					</select>
				</Seccion>
				<Seccion>
					<Button variant="contained" loadingPosition="start" startIcon={<CloudUploadIcon />} loading={send} >subir</Button>	
				</Seccion>		
			</Formulario>
		</Container>
			
	
	
	
	

			)
}